import { useContext } from 'react'
import { SideSheetIndexContext } from '../context/SideSheetIndexContext'

export function useSideSheetIndex(): number {
  return useContext(SideSheetIndexContext)
}
